import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * AnonymousRoute component
 * Prevents authenticated users from accessing routes that are meant for anonymous users only
 * Redirects authenticated users to the dashboard
 */
function AnonymousRoute({ children }) {
  const { user, loading } = useAuth();

  // Show loading state if auth is still being checked
  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to dashboard if user is already authenticated
  if (user) {
    return <Navigate to="/memberships" />;
  }

  // Render children if not authenticated
  return children;
}

export default AnonymousRoute;